import {
  $,
  api,
  appState,
} from './app-state';

let textSendTrigger: HTMLElement | null = null;

function closeTextSendLayer(restoreFocus = true): void {
  const layer = $('text-layer');
  layer.classList.add('hidden');
  layer.setAttribute('aria-hidden', 'true');
  if (restoreFocus) textSendTrigger?.focus({ preventScroll: true });
  textSendTrigger = null;
}

function bindTextSend(): void {
  const layer = $('text-layer');
  layer.setAttribute('aria-hidden', 'true');
  $('tb-paste').addEventListener('click', (event) => {
    textSendTrigger = event.currentTarget as HTMLElement;
    void pasteLocalClipboard(layer);
  });
  $('text-cancel').addEventListener('click', () => closeTextSendLayer());
  $('text-send').addEventListener('click', () => {
    if (appState.sessionMode === 'view') return;
    const val = ($('text-input') as HTMLTextAreaElement).value;
    if (!val || !appState.controller) return;
    void appState.controller.sendClipboardText(val).then((sent) => {
      if (sent) closeTextSendLayer();
    });
  });
  layer.addEventListener('click', (event) => {
    if (event.target === layer) closeTextSendLayer();
  });
  layer.addEventListener('keydown', (event) => {
    if (layer.classList.contains('hidden')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeTextSendLayer();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(layer.querySelectorAll<HTMLElement>(
      'button:not([disabled]), textarea:not([disabled]), input:not([disabled])',
    ));
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
}

async function pasteLocalClipboard(layer: HTMLElement): Promise<void> {
  if (appState.sessionMode === 'view') return;
  if (!appState.controller) return;
  try {
    const text = await api.readClipboard();
    if (text) {
      await appState.controller.sendClipboardText(text);
      return;
    }
  } catch {
    // 下面打开手动输入框作为浏览器权限/安全上下文降级。
  }
  openTextSendLayer(layer);
  ($('text-input') as HTMLTextAreaElement).focus();
  $('session-status').textContent = '浏览器无法读取剪贴板，请在输入框粘贴后发送';
}

function openTextSendLayer(layer: HTMLElement): void {
  if (!textSendTrigger && document.activeElement instanceof HTMLElement) textSendTrigger = document.activeElement;
  $('text-title').textContent = '发送文本到远端剪贴板';
  $('text-hint').textContent = '非 https 环境下浏览器剪贴板受限，用此框把文字送到被控端。';
  ($('text-input') as HTMLTextAreaElement).value = '';
  $('text-send').classList.remove('hidden');
  layer.classList.remove('hidden');
  layer.setAttribute('aria-hidden', 'false');
}

export {
  bindTextSend,
  closeTextSendLayer,
  pasteLocalClipboard,
  openTextSendLayer,
};
